import type { DialogConfig } from '#types/config/components/dialog'
import type { RecursivePartial } from '#types/utils'

export default {
  brandClasses: {
    footerShippingTaxHint: 'text-xs',
    footerTotalAmount: 'title-4',
    footerTotalLabel: 'title-4',
    promo: 'text-sm',
    savingsDetails: 'subtitle-5 c-grey-30',
    savingsHeading: 'title-4',

    // TODO: to be phased out after GLOBAL15-108791 goes live
    notification: 'items-center',
    productName: 'title-5',
    productPrice: 'text-sm',
    productVariants: 'text-sm',
    savings: '-mt-4 -mx-6 b-b',
    savingsContainer: 'b-b b-grey-50 bg-grey-90 px-4 py-2 text-center',
    savingsText: 'text-sm'
  }
} satisfies RecursivePartial<DialogConfig['miniCart']>
